import Cookies from 'js-cookie';
import { uuid } from 'utils/generics';

/* eslint-disable prefer-destructuring */
export function getCookiesMap(cookiesString: string) {
    return cookiesString
        .split(';')
        .map((cookieString) => {
            return cookieString.trim().split('=');
        })
        .reduce((acc, curr) => {
            acc[curr[0]] = curr[1];
            return acc;
        }, {});
}

export function getCookieUserId(cookiesString: string) {
    const cookie: any = getCookiesMap(cookiesString);
    if (cookie?.user_id) {
        return cookie['user_id'];
    }
    return '';
}

export function parseHeaderCookies(cookies: any) {
    try {
        const parsedCookies: any = {};
        cookies?.split(';')?.forEach((cookie: any) => {
            const parts = cookie.match(/(.*?)=(.*)$/);
            if (parts?.length > 0) {
                parsedCookies[parts[1]?.trim()] = (parts[2] || '').trim();
            }
        });
        return parsedCookies;
    } catch (e) {
        console.error('parse header cookie: ', e);
        return {};
    }
}

export function setIframeUserIdCookie() {
    const view = new URL(window.location.href)?.searchParams?.get('view');
    const localView = localStorage.getItem('view');
    if (view === 'iframe' || localView === 'iframe') {
        const userId = Cookies.get('user_id') || localStorage.getItem('userId');
        const userAuthKey = Cookies.get('user_auth_key');
        if (userAuthKey) {
            document.cookie = `user_auth_key=${userAuthKey};samesite=none;secure;expires=Tue, 19 Jan 2038 03:14:07 GMT;path=/`;
        }
        if (userId)
            document.cookie = `user_id=${userId};samesite=none;secure;expires=Tue, 19 Jan 2038 03:14:07 GMT;path=/`;
    }
}

export function setTrackerIdCookie() {
    // Check if tracker_id cookie already exists
    const existingTrackerId = Cookies?.get('trackerid') || '';

    if (!existingTrackerId) {
        // Generate a unique tracker ID using the existing uuid utility
        const trackerId = uuid(32);
        Cookies?.set('trackerid', trackerId);
    }
}
